// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2JLLI","location":"Header_location__1Yc8j"};